import React, { useContext, useEffect, useState } from "react";
import UserContext from "../../../../context/UserContext";
import { Modal, Button, Table } from "react-bootstrap";
import { EditOutlined } from "../../../../helpers/icons/antDesignIcons";
import USER_ROLES from "../../../../constants/userRoles";
import { getLast5ActivityLogsByUserId } from "../../../../api/logApi";
import "../CompanySettingsPage.scss";

const SettingsUserMoreInfoModal = ({
  show,
  onClose,
  userInfo,
  onEditUser,
  roleMapping,
  t, // Translation function
}) => {
  const { user } = useContext(UserContext);
  const userId = Number(user.userId);
  const [user5LatestActivityLogs, setUser5LatestActivityLogs] = useState([]);
  const [showUser5LatestActivityLogs, setShowUser5LatestActivityLogs] =
    useState(false);

  // Function to fetch the last 5 activity logs for the user
  const fetchUser5LatestActivityLogs = async () => {
    try {
      const response = await getLast5ActivityLogsByUserId(
        userInfo._id,
        user.company_id
      );
      if (response && response.length > 0) {
        setUser5LatestActivityLogs(response);
      }
    } catch (error) {
      console.error("Error fetching user activity logs:", error);
    }
  };

  // Fetch the last 5 activity logs when the modal is opened
  useEffect(() => {
    if (show) {
      fetchUser5LatestActivityLogs();
    }
  }, [show, userInfo._id]);


  return (
    <Modal show={show} onHide={onClose} centered size="md">
      <Modal.Header closeButton>
        <Modal.Title>{`${userInfo.lastname} ${userInfo.firstname}`}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* If user is a superadmin, show the companyid as well */}
        {user.roles === USER_ROLES.SUPER_ADMIN && (
          <p>
            {t("companyId")}: {userInfo.company_id}
          </p>
        )}
        <p>
          {t("email")}: {userInfo.email}
        </p>
        <p>
          {t("role")}: {roleMapping[userInfo.roles]}
        </p>
        <p>
          {t("phoneNumber")}: {userInfo.phonenumber}
        </p>
        <p>
          {t("status")}:{" "}
          {userInfo.status === "A"
            ? t("active")
            : userInfo.status === "I"
            ? t("inactive")
            : t("pending")}
        </p>
        <p>
          {t("email_notification")}:{" "}
          {userInfo.emailnotification ? t("on") : t("off")}
        </p>
        <p>
          {t("email_report")}: {userInfo.emailreport ? t("on") : t("off")}
        </p>
        {/* <p>Telephely: {modalUserInfo.location}</p> */}
        <p>
          {t("settingsNotifications")}:{" "}
          {userInfo.emailnotification ? t("on") : t("off")}
        </p>
        {/* Only show activity logs if superadmin, or if viewing another user's account */}
        {(user.roles === USER_ROLES.SUPER_ADMIN ||
          userId !== Number(userInfo._id)) && (
          <div>
            <span>{t("users_last_5_activity_logs")}: </span>
            {user5LatestActivityLogs.length > 0 ? (
              <>
                <Button
                  variant="link"
                  onClick={() =>
                    setShowUser5LatestActivityLogs(!showUser5LatestActivityLogs)
                  }
                >
                  {showUser5LatestActivityLogs ? t("hide") : t("show")}
                </Button>
                {showUser5LatestActivityLogs && (
                  <Table
                    striped
                    bordered
                    hover
                    size="sm"
                    responsive
                    className="sumim-log-table"
                    style={{
                      width: "100%",
                      tableLayout: "fixed",
                    }}
                  >
                    <colgroup>
                      <col style={{ width: "50%" }} />
                      <col style={{ width: "50%" }} />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>{t("log_timestamp")}</th>
                        <th>{t("log_notice")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {user5LatestActivityLogs.map((log, index) => (
                        <tr key={index}>
                          <td>
                            {new Date(log.log_timestamp).toLocaleString()}
                          </td>
                          <td>{log.log_notice}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </>
            ) : (
              <span>{t("no_activity_logs")}</span>
            )}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        {/* If user is a superadmin, see the button */}
        {user.roles === USER_ROLES.SUPER_ADMIN && (
          <Button variant="primary" onClick={() => onEditUser(userInfo)}>
            <EditOutlined /> {t("edit")}
          </Button>
        )}
        {/* If user is a company admin, they can see this button at their own account */}
        {user.roles === USER_ROLES.COMPANY_ADMIN &&
          user._id === userInfo._id &&
          user.companyId === userInfo.companyId && (
            <Button variant="primary" onClick={() => onEditUser(userInfo)}>
              <EditOutlined /> {t("edit")}
            </Button>
          )}
        {/* If user is a company admin, they can see this button at their own company users */}
        {user.roles === USER_ROLES.COMPANY_ADMIN &&
          userInfo.roles === USER_ROLES.COMPANYUSER &&
          userInfo.companyId === user.companyId && (
            <Button variant="primary" onClick={() => onEditUser(userInfo)}>
              <EditOutlined /> {t("edit")}
            </Button>
          )}
        <Button variant="secondary" onClick={onClose}>
          {t("cancel")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SettingsUserMoreInfoModal;
